var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({staticClass:"rounded-lg",attrs:{"id":_vm.id,"items":_vm.items,"value":_vm.value,"solo":"","flat":"","outlined":"","item-value":"value","item-text":"text"}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }